import React, { useState } from "react";
import { DiscipleshipPathwayFlow as DiscipleshipPathwayFlowType } from "api/Community/CommunityInterfaces";
import DiscipleshipPathwayFlow from "./DiscipleshipPathwayFlow";
import { Box, Container, Stack, Typography } from "@mui/material";
import BasePaper from "components/Flow/Nodes/StandardNode/StandardNodeFunctionality/BasePaper";

interface DiscipleshipPathwayDetailProps {
  discipleshipPathway: DiscipleshipPathwayFlowType | null;
  selectedNode: any | null;
  onNodeSelect: (node: any | null) => void;
}

const DiscipleshipPathwayDetail: React.FC<DiscipleshipPathwayDetailProps> = ({
  discipleshipPathway,
  selectedNode,
  onNodeSelect,
  
}) => {
  const [loading, setLoading] = useState(false);

  return (
    <Box sx={{ mx: 2, my: 2 }}>
      <BasePaper>
        <Stack direction="column" spacing={2} mb={1}>
          <Typography variant="h3">Discipleship Pathway</Typography>
          <Typography variant="body2">A visual representation of the general stages in a discipleship process, as individuals gain spiritual maturity.</Typography>
        </Stack>
      </BasePaper>
        
      <DiscipleshipPathwayFlow
        nodes={(discipleshipPathway?.nodes ?? [])}
        edges={(discipleshipPathway?.edges ?? [])}
        onNodeSelect={onNodeSelect}
      />

    </Box>
  );
};

export default DiscipleshipPathwayDetail;
